import React from 'react';

import { styled, useTheme } from '@mui/material/styles';
import { Box, Divider, Typography } from '@sunwisesoftware/sunwise-ui';
import { useLocation } from 'react-router-dom';

import { HIIDDEN_FOOTER_ROUTES } from 'common/constants';

const StyledFooter = styled(Box)(({ theme }) => ({
    background: theme.palette.background.paper,
    padding: '15px',
    position: 'relative',
    zIndex: 2,
}));

const Footer = () => {
    const theme = useTheme();
    const location = useLocation();
    const route = location.pathname.slice(
        0,
        location.pathname.lastIndexOf('/'),
    );
    if (HIIDDEN_FOOTER_ROUTES.includes(route)) return null;
    return (
        <Box sx={{ mt: 'auto' }}>
            <Divider />
            <StyledFooter>
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.primary.main,
                        textAlign: 'center',
                    }}
                >
                    {import.meta.env.VITE_ENV}-{import.meta.env.VITE_VERSION}
                </Typography>
            </StyledFooter>
        </Box>
    );
};

export default Footer;
